import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "online",
  "use": "online-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"online\"><rect width=\"14\" height=\"14\" x=\"1\" y=\"1\" rx=\"7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol